<section class="child">
    <div c-search-box search-state='contract.search'></div>
</section>
<section class="child">
    <nav>
        <c-offline-form-message type="'ContractflowConfig'"/>
    </nav>
</section>
<section class="child">
    <nav>
        <c-tree-explorer config="shortcutsConfig"></c-tree-explorer>
    </nav>
</section>